import { useEffect } from 'react';
import { skipToken } from '@reduxjs/toolkit/query';
import {
  useGetLogisticTaskIdQuery,
  useLazyGetLogisticStatesQuery,
} from '../../../../../../entities/logistic/logisticTasks/redux/logisticTasks.api';
import getMaxMin from '../utils/getMaxMin';
import getDomain from '../utils/getDomain';

const useRequests = ({ taskId, producerId }) => {
  const [
    fetchGetLogisticStatesQuery,
    { data: { data: dataLogisticStates = null } = {}, isLoading: isLoadingLogisticStates, error: errorLogisticStates },
  ] = useLazyGetLogisticStatesQuery();

  useEffect(() => {
    if (!taskId || !producerId) return;
    fetchGetLogisticStatesQuery({
      taskId,
      producerId,
    });
  }, [taskId, producerId]);

  const {
    data: dataLogisticTaskId,
    isLoading: isLoadingLogisticTaskId,
    error: errorLogisticTaskId,
  } = useGetLogisticTaskIdQuery(
    taskId
      ? {
          id: taskId,
        }
      : skipToken,
  );

  const { maxVolume, minVolume } = dataLogisticTaskId?.source?.balanceCapacityParameters || {};

  return {
    isLoading: isLoadingLogisticStates || isLoadingLogisticTaskId,
    error: errorLogisticStates || errorLogisticTaskId,
    transportVolumePoint: dataLogisticStates?.transportVolumePoint || [],
    maxVolume,
    minVolume,
    yDomain: getDomain({
      maxVolume,
      minVolume,
      ...getMaxMin(dataLogisticStates?.transportVolumePoint),
    }),
  };
};

export default useRequests;
